import { Dayjs } from "dayjs";
import { LinearChartSelection } from "./chart";

export enum DateFormat {
  FullDate = "MMMM D, YYYY",
  ShortDate = "MMM D",
  User = "YYYY-MM-DD",
  Time = "h:mm A",
  Year = "YYYY",
}

export type FormatDateChartLabelsProps = {
  range: LinearChartSelection;
  dates: Array<Dayjs>;
};
